import React from 'react';
import { BriefFitProvider } from '../PartnershipBrief/BriefPage';
import { BriefPageOne } from '../PartnershipBrief/BriefPageOne';
import { BriefPageTwo } from '../PartnershipBrief/BriefPageTwo';
import { LaunchPageOne } from '../PartnershipBrief/LaunchPageOne';
import { usePricing } from '../../contexts/PricingContext';
import { ModelSheet } from '../FinancialModel/ModelSheet';
import { DocPagingProvider } from '../../contexts/DocPagingContext';
import { useFinancialModel } from '../../hooks/useFinancialModel';

/**
 * The three-page proposal: the Partnership Brief (pages 1–2) followed by the
 * one-page Financial Model (page 3). All pages share one fit, so type sizes
 * match across the whole document.
 */
export function FullProposal() {
  const model = useFinancialModel();
  // Go-to-market + Find a leader: the launch story (leader first, then the
  // channel) replaces the standard partnership pages.
  const {
    isGoToMarket
  } = usePricing();
  return <BriefFitProvider data-id="element-1257" data-mp="3pt7qdousny0s">
      <div className="space-y-10" data-id="element-1258" data-mp="1w4my8d6lb9ot">
        <DocPagingProvider offset={0} total={3} data-id="element-1259" data-mp="1w5o84ebvdq4y">
          {isGoToMarket ? <LaunchPageOne data-id="element-1260" data-mp="213zhkny95ymn" /> : <BriefPageOne data-id="element-1261" data-mp="212emmx810do9" />}
          <BriefPageTwo variant={isGoToMarket ? 'launch' : undefined} data-id="element-1262" data-mp="212woqahddm43" />
        </DocPagingProvider>
        <DocPagingProvider offset={2} total={3} data-id="element-1263" data-mp="1me0jel6p6n76">
          <ModelSheet model={model} data-id="element-1264" data-mp="1rdd5h3pqvq8p" />
        </DocPagingProvider>
      </div>
    </BriefFitProvider>;
}